function dateFormat(date, fmt = 'YYYY-mm-dd HH:MM:SS') {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }
  }
  return fmt
}

function dateFromString(dateString) {
  // str like yyyy-MM-dd hh:mm:ss
  if (dateString) {
    var arr1 = dateString.split(' ')
    var sdate = arr1[0].split('-')
    var date = new Date(sdate[0], sdate[1] - 1, sdate[2])
    return date
  }
}

function convertMessageObj(orgMessage, self, friend, read = true) {
  return {
    id: orgMessage.messageid || '-1',
    isSender: orgMessage.friendid === self.id,
    avatar: orgMessage.friendid === self.id ? self.avatar : friend.avatar,
    time: orgMessage.time ? new Date(orgMessage.time) : new Date(),
    message: orgMessage.content || '',
    read: orgMessage.read === undefined ? read : orgMessage.read
  }
}

function getuid() {
  return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36)
}

function validatePhone(rule, str, callback) {
  const reg = /^1\d{10}$/
  if (!reg.test(str)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

export default {
  dateFormat,
  dateFromString,
  convertMessageObj,
  getuid,
  validatePhone
}



// WEBPACK FOOTER //
// ./src/util/index.js